import consumer from './consumer'

export const subscribeToEntriesMassAssignmentChannel = ({ onUpdate }) => {
  consumer.subscriptions.create('EntriesMassAssignmentChannel', {
    initialized () {
      this.update = this.update.bind(this)
    },

    received (notification) {
      this.update(notification)
    },

    update (notification) {
      onUpdate(notification)
    },
  })
}
